import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "usehooks-ts";
import { Icon } from "../../../../components";
import { IconType } from "@sellar-io/components";
export const DiscoveryFilterButton = ({
  title,
  onClick,
  selected,
  icon,
  className,
}: {
  title: string;
  onClick: () => void;
  icon?: IconType;
  selected?: boolean;
  className?: string;
}) => {
  const isDesktop = useMediaQuery("(min-width: 1083px)");

  return (
    <button
      type="button"
      className={twMerge(
        "flex w-fit flex-none cursor-pointer gap-2 rounded-md border border-zinc-300 bg-white px-3 py-2 text-sm leading-[18px] font-medium",
        isDesktop &&
          "hover:bg-zinc-100 hover:stroke-zinc-300 hover:text-zinc-800",
        selected && "border-zinc-500 bg-zinc-200",
        isDesktop &&
          selected &&
          "hover:bg-zinc-300 hover:stroke-zinc-400 hover:text-zinc-800",
        className,
      )}
      onClick={onClick}
    >
      {icon && <Icon icon={icon} />}
      {title}
    </button>
  );
};
